import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { catchError, map, tap } from 'rxjs';
import { ApplicationControllerService } from './cc-api/services/application-controller.service';
import { of } from 'rxjs';

@Injectable()
export class PasswordGuard implements CanActivate {
  private roles: string[] = [];

  constructor(
    private applicationControllerService: ApplicationControllerService,
    private router: Router,
  ) {}

  canActivate() {
    return this.applicationControllerService.meUsingGET().pipe(
      map((res) => {
        return true;
      }),
      tap((authenticated) => {
        if (authenticated) {
          this.router.navigate(['/home']);
        }
      }),
      catchError((err) => {
        return of(true);
      }),
    );
  }
}
